export enum CLSLogType {
  AdministratorLog = 0,
  AuditLog = 1,
  ApplikationsLog = 2,
  ApplikationsLogwithDebug = 3,
  TransaktionsLog = 4,
  RevisionsLog = 5,
}
